import BaseApi from './BaseApi.js';

class SimulatorsApi extends BaseApi {
	static get endpoint() {
		return this.buildOrgEndpoint('/simulator');
	}

	// Add simulator to organization
	// POST /api/v1/org/{organizationUnique}/simulator
	static async addSimulator(simulatorData) {
		return await this.post(this.endpoint, simulatorData);
	}

	// Update simulator
	// PUT /api/v1/org/{organizationUnique}/simulator/{simulatorId}
	static async updateSimulator(simulatorId, simulatorData) {
		const endpoint = `${this.endpoint}/${simulatorId}`;
		return await this.put(endpoint, simulatorData);
	}

	// Delete simulator
	// DELETE /api/v1/org/{organizationUnique}/simulator/{simulatorId}
	static async deleteSimulator(simulatorId) {
		const endpoint = `${this.endpoint}/${simulatorId}`;
		return await this.delete(endpoint);
	}
}

export default SimulatorsApi;
